module.exports = __webpack_public_path__ + "img/iceberg.22d9abe2.png";